import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, tap } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class LastSearchService {

    constructor(private $http: HttpClient) {
    }

    getLastSearch() {
        return this.$http.get('/api/lastSearch').pipe(
            // transform into a useful form
            tap(s => {
                //add an observation point
                return s
            }),
            map((ls: any) => {
                const searchSubject = ls.searchSubject.toCamelCase();
                const newState: string = `search.${searchSubject}Summary`;//.toCamelCase();
                if (ls.searchName) {
                    return {
                        newState: newState,
                        stateArgs: {
                            guid: ls.guid,
                            name: ls.searchName.urlEncode()
                        }
                    }
                }
                else {
                    return {
                        newState: newState,
                        stateArgs: {
                            guid: ls.guid,
                            name: ""
                        }
                    }
                }
            })
        );

                //     $state.go(newState, { guid: $scope.lastSearch.guid, name: $scope.lastSearch.searchName.urlEncode() });
                //   }
                //   else {
                //     $state.go(newState, { guid: $scope.lastSearch.guid, name: "" });
                //   }
                //         }),
                // var newState = "search." + ($scope.lastSearch.searchSubject + ' Summary').toCamelCase();
                // if ($scope.lastSearch.searchName) {
                //   $state.go(newState, { guid: $scope.lastSearch.guid, name: $scope.lastSearch.searchName.urlEncode() });
                // }
                // else {
                //   $state.go(newState, { guid: $scope.lastSearch.guid, name: "" });
                // }
           
    }

    // repeat() {
    //     var newState = "search." + ($scope.lastSearch.searchSubject + ' Summary').toCamelCase();
    //     if ($scope.lastSearch.searchName) {
    //         $state.go(newState, { guid: $scope.lastSearch.guid, name: $scope.lastSearch.searchName.urlEncode() });
    //     }
    //     else {
    //         $state.go(newState, { guid: $scope.lastSearch.guid, name: "" });
    //     }
    // }

    // downloadFile(url: string): void {
    //     this.$http.get('/api/lastSearch')
    //         .subscribe((resp) => {
    //             const contentDisposition = resp.headers.get('content-disposition');
    //             const filenameHeader = contentDisposition.split(';')[1];
    //             const filename = filenameHeader.split('=')[1].replace(/\"/g, "");;

    //             this.download(resp.body, filename);
    //         },
    //             error => console.log('Error downloading the file.', error),
    //             () => console.info('OK'));
    // }
}